<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { companyDtoFields } from "../../utils/TableFields/company-dto.fields";
  import { PermissionService } from "../../utils/misc/permission-utils";
    import { user } from "../../app.store";

  $: tableFields = [...companyDtoFields, ...$tableCustomFields];

  let cancreate : boolean = PermissionService.isAllowedTo($user, 'companies.cancreate');
  let candelete : boolean = PermissionService.isAllowedTo($user, 'companies.candelete');
  let canedit : boolean = PermissionService.isAllowedTo($user, 'companies.canedit');

  let issupplier = window.location.pathname.indexOf("supplier") >= 0;
 

  import {
    filter,
    loading,
    records,
    pagination,
    initList,
    onCreate,
    onEdit,
    onDelete,
    onPageChange,
    search,
    clearSearch,
    tableCustomFields,
  } from "./company.store";
import FormField from "../../components/Form/FormField.svelte";
import Switch from "../../components/Form/Fields/Switch.svelte";
import Icon from "../../components/Icon.svelte";
import Button from "../../components/Button.svelte";

  onMount(initList);

</script>

<MainLayout>
  <SearchHeader
    entitySingular={issupplier?'fornitore':"cliente"}
    entityPlural={issupplier?'fornitori':"clienti"}
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  >
  <div slot="search" class="level">
     
    <div class="level-item">
      <div>
         
        <FormField usageHelp="Mostra aziende cessate">
          <Switch
            name=""
            condensed={true}
            altText="Mostra aziende cessate"
            bind:value={$filter.criteria.cessate}
            on:toggle={search}
          />
        </FormField>
      </div>
    </div>
 
<!--
    <div class="level-item">
      <p class="control">
        <Button on:click={search}>
          <Icon name="search" />

          <span> Cerca </span>
        </Button>
      </p>
    </div>

    <div class="level-item">
      <p class="control">
        <Button on:click={clearSearch}>Azzera</Button>
      </p>
    </div> 
    -->
  </div>
  </SearchHeader>

  <Table
    loading={$loading}
    fields={tableFields}
    records={$records}
    pagination={$pagination}
    createEnabled={cancreate}
    editEnabled={false}
    showEnabled={true}
    deleteEnabled={candelete}
    on:create={(_) => onCreate()}
    on:show={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</MainLayout>
